import React from 'react'
// import Header from '@/components/header'
import './index.scss'
import { Bscroll } from '@/components/bscroll'
import {connect} from 'react-redux'
const mapStateToProps = (state) => ({
  tenant : state.getIn(['tenantReducer','tenant'])
})
const ServiceTerm = (props) => {
  let company = props.tenant
  return (
    <div className="service-term__box">
      {/* <Header tit={company + '服务协议'} /> */}
      <div className="service-term__show">
        <div className="service-term__list">
          <Bscroll scrollX={false} scrollY={true} bounce={{bottom:false}}>

            <div>
              <h2>{company}服务协议</h2>
              <p>本《{company}服务协议》由《用户服务协议（司机端）》、《{company}用户规则》以及《网约车行业个人信息共享授权书》三部分组成。请您仔细阅读协议的全部条款，尤其是协议中黑色加粗的部分。请您务必在审慎和完整理解各条款内容、内涵的基础上，点击"同意"。如您不能完全同意协议中的内容，或无法完全理解其中的含义，您接受不使用{company}的服务。您使用{company}提供的服务，即表示您已审慎和完整阅读、理解和接受《{company}服务协议》的全部内容。</p>
              <h3>第一部分∶</h3>
              <h4>用户服务协议（司机端）</h4>
              <h5>本协议更新于∶2021年04月19日</h5>
              <p>{company}（或称"本产品"）将按照本协议约定之内容为用户（下称"用户"或"您"）提供服务，本《用户服务协议（司机端）》、《隐私政策及录音录像信息收集协议》以及其他经本产品不时修订、修改，并在本产品内发布的通知、规则或规定等，均为构成本协议的整体（下称"本协议"）。请您仔细阅读本协议的全部条款，尤其是协议中黑色加粗的部分。请您务必在审慎和完整理解本协议各条款内容、内涵的基础上，点击"同意"。如您不能完全同意本协议中的内容，或无法完全理解其中的含义，您接受不使用本产品服务。您点击"同意"、开始使用本产品，即表示您已审慎和完整阅读、理解和接受本协议的全部内容，成为本协议的当事一方，本协议对您及本产品均具有法律约束力。 </p>

              <span className="tit_span">1.服务内容</span>
              <p>1.1{company}作为网约车平台的司机端，为网约车驾驶员（即"用户"或"您"）提供来自乘客需求的网约车订单匹配、派送及相关服务（下称"服务"），由用户自行决定是否接单并实际为乘客提供线下运输服务。</p>
              <p>1.2您可以通过{company}提出接收网约车叫车订购单派送的服务需求，我们将按照您的需求为您提供和派送相匹配的网约车服务需求订单。</p>
              <p>1.3我们将做出合理的努力，让您获得服务，但这受制于您提出服务需求时所在位置周边是否有提出网约车服务的乘客。</p>
              <p>1.4快车订单派送服务：如果您为在{company}依规注册账号的快车驾驶员，我们将为您提供快车网约车乘客订单匹配和派送服务。 </p>
              <p>1.5专车订单派送服务：如果您为在{company}依规注册账号的专车驾驶员，我们将为您提供专车网约车乘客订单匹配和派送服务;您同意，在合理时候，{company}也会为您提供快车网约车乘客订单匹配和派送服务。 </p>
              <span className="tit_span">2.您的账号</span>
              <p>2.1如您使用{company}的服务，您需要先注册账号，并确保注册信息的真实性、准确性和完整性，注册信息如有变更，您应及时更新以持续保持提供信息的真实性和有效性，并依据法律规定和本合同约定对所提供的信息承担相应的法律责任。若用户所提供的信息与事实不符或所提供的信息已变更而未及时更新或有任何误导之嫌或有其他违反本款的行为，{company}有权在自行获悉上述情形的情况下暂停向其提供任何服务，并无需就此向用户承担任何责任。</p>
              <p>2.2为注册账号，您需要提供包括但不限于您的姓名、手机号码、 身份证信息、 驾驶证信息、 行驶证信息、 面部识别生物信息，以及其他关资料和信息（"账户信息"）以完成注册; 账户信息的收集、处理和使用规则和政策，将在《隐私政策》中详细约定，您可以随时在{company} 内查阅最新的《隐私政策》内容。</p>
              <p>特别提示，您确认并同意，为注册账号成为专/快车驾驶员，我们将收集您以下重要敏感信息∶</p>
              <p>2.2.1您需提供手机号码，为您创建用户账号用以识别您在本产品的网络身份后为您提供服务;</p>
              <p>2.2.2您需要提供姓名、身份证（正反面照片及您手持身份证的照片）、驾驶证（正页和副页）、网络预约出租车驾驶员证照片，从业资格证（如有）照片;</p>
              <p>2.2.3您需要提供通过{company}提供服务的有合法资质的车辆45°照片、您与上述车辆的合影照片、车辆品牌、型号、颜色、车牌号码、行驶证（正页和副页）、网络预约出租汽车运输证照片以及车辆监督卡、交强险照片、商业险照片;</p>
              <p>2.2.4您需要提供用于收款的银行卡或第三方支付账号信息;</p>
              <p>2.2.5在您进行人脸识别时，{company}以及为本产品提供技术服务的委托方将收集您的面部识别特征; </p><p>2.2.6{company}还需要查询您的信用信息、是否有犯罪记录、是否有不良行为记录或其他不适宜作为驾驶员的情形;</p>
              <p>2.2.7请您了解，前述信息是基于法律法规要求以及保护{company}用户人身财产安全所必需。部分信息服务平台，如北京易行出行旅游有限公司或滴滴出行科技有限公司等还将为提升安全保障水平的需要，对您的前述信息进行二次审查，如未通过该平台安全审查可能会影响您为使用该信息服务平台的用户提供服务。</p>
              <p>2.3 {company}将通过您的账号及密码 （或手机验证码）来识别用户指令。请您务必注意和保管好您的账户信息，不得将您的账户信息转让、售卖、赠与、借用、租用、泄露给任何第三方或以其他方式许可第三方使用;您必须注意和知晓的是，如果您将账户信息以前述方给予任何第三方，使该第三方得以使用该等账户信息登录您的账户、使用本产品，则该第三方登录您账户后在本产品上的一切行为均代表您本人，您应为该第三方登录您的账户和使用本产品的一切行为及其后果承担相应责任。</p>
              <p>2.4请您发现任何账号异常情况或其他账号安全问题的，请立即联系我们，并提供该等异常情况的描述、相关证据等，您可提请本产品暂停您账号的相关服务;在必要的情况下，本产品有权向相关司法机关报案。在收到您举报的异常情况后，请您理解我们需要对相关情况进行识别、确认、技术分析和讨论应对措施，但我们均将以最大努力尽快处理和解决您举报的异常情况。</p>
              <p>2.5您确认并同意，{company}有权对（1）您长期不登录的账号，或 （2）您提供了不实、虚假或错误信息的账号，进行收回或设定功能限制，由此带来的损失由您自行承担。 </p>
              <span className="tit_span">3.服务期间</span>
              <p>本协议的服务期间是指您向乘客提供网约车服务的订单成立时起至乘客到达订单目的地下车时止。在订单成立前或乘客达到目的地下车后，您在此听单期间，您的驾驶行为属于您的个人行为，与本协议服务无关。 </p>
              <span className="tit_span">4.费用结算</span>
              <p>4.1您同意并认可{company}现行提供并可能根据市场情况不时合理更新本协议项下的服务价格标准，您可以在{company}上查看网约车订单匹配和派送服务的价格，请您留意{company}内公示的服务价格，并根据自主意愿选择您是否继续使用{company}的服务。</p>
              <p>4.2您可以通过您绑定的银行卡就您在{company}接收网约车订单、为乘客提供承运服务的费用（"车费"）进行提现。您提取车费时，除了受到本协议的约束之外，还要接受和遵守您所选择的电子支付服务商及信用卡/借记卡发卡行的条款和政策的约束。我们对于电子支付服务商或银行发生的错误不承担责任。我们将获取与您使用服务相关的特定交易明细，在使用这些信息时我们将严格遵守《隐私政策》、相关法律法规和公司的各项政策的规定。 </p>
              <p>4.3司机个人费用∶ 您在{company}应用程序使用过程中产生的所有通信数据流量费用 （该服务与费用由司机的通信运营商提供和收取）及其他个人费用等，由您个人自行支付，我们不代为收取，亦不代为支付。</p>
              <span className="tit_span">5.产品更新和升级</span>
              <p>5.1我们为不同的操作系统开发了不同的应用程序版本，您应当根据实际情况选择下载和安装合适的版本。如您未能依据您所适用的个人设备下载对应操作系统的应用程序版本，{company}不保证该等不匹配的版本与您个人设备的适配性和可用性，亦不保证所有的版本提供的服务的一致性。</p>
              <p>5.2为了给您提供更好的服务、提升您的用户体验，您确认并同意接受我们为您不时提供{company}的更新（包括但不限于版本升级和替换、产品功能修改和强化等）。{company}新版本发布后，旧版本的应用程序可能无法使用，{company}不保证旧版本应用程序可继续使用相应服务，因此请您关注产品内通知，并下载和安装更新后的版本。 </p>
              <span className="tit_span">6.第三方链接</span>
              <p>{company}上可能保留有第三方网站（或应用程序）或网址的链接及第三方服务，是否访问这些链接或接受相应服务将由您自行做出决定，{company}并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。如果您决定访问任何链接的第三方网站（或应用程序），其可能带来的后果和风险全部由您自行承担。 </p>
              <span className="tit_span">7.知识产权</span>
              <p>7.1您在此确认并同意，您并不因使用{company}应用程序而对本产品之软件、代码、设置、企业名称、商标、图标和/或全部内容，享有任何知识产权（包括但不限于著作权、专利、技术秘密、商标等所有权和申请权等），该等知识产权归属于本产品或相关权利人，受法律保护。如果相关内容未含权利声明，并不代表本产品对其不享有权利和不主张权利，您应根据法律、法规及诚信原则尊重权和人的合法权益并合法使用本产品。</p>
              <p>7.2未经{company}书面许可，任何单位及个人不得以任何方式或理由对本产品之软件、代码、设置、企业名称、商标、图标和/或全部内容进行使用、复制、修改、抄录.传播或与其它产品捆绑使用、销售，或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印（未作修改，且须保留该内容中的版权说明或其他所有权的说明） 除外。</p>
              <p>7.3在使用本产品服务时，您不得以任何复制、修改，或采用任何不被允许或授权的方式使用本产品，包括但不限于∶</p>
              <p>7.3.1 对本产品进行反向工程，抽取本产品代码，改变、修改、篡改本产品，或基于本产品制作衍生产品或进行商业开发;</p>
              <p>7.3.2 通过本产品发送、存储或传输病毒或其他有害计算机代码;</p>
              <p>7.3.3 以任何方式许可、再许可、出售、转售、转让、分配、分发本产品或以任何其他方式提供给任何第三方; </p>
              <p>7.3.4 干扰或阻挠本产品服务，或以未经授权的方式收集本产品及本产品其他用户信息;</p>
              <p>7.3.5 以未经授权的方式，或通过模拟真人的自动程序注册本产品账号;</p>
              <p>7.3.6 尝试通过本产品未经授权地访问其他网站、应用程序、服务或系统，或未经授权将本产品在其他网络或渠道进行分销或推广;</p>
              <p>7.3.7 使用任何机器人程序、爬虫程序或其他自动化设备、强制程序，控制本产品或从本产品爬取内容;以及 </p>
              <p>7.3.8 其他任何试图规避本协议及本产品相关规则、政策项下义务的行为。 </p>
              <span className="tit_span">8.违约责任</span>
              <p>8.1您理解并同意，我们有权根据本协议及本产品相关规则认定您是否违约。如您的行为构成违约的，我们有权根据您违约的严重程度对您采取相应的措施，包括但不限于∶</p>
              <ul>
                <li>（1）暂停您的账号登录和访问权限;</li>
                <li>（2）暂停服务;</li>
                <li>（3）注销账号、终止服务;</li>
                <li>（4）暂停账户提现功能;</li>
                <li>（5）划扣违约金;</li>
                <li>（6）随时单方终止本协议;或</li>
                <li>（7）其他可适用的限制措施。</li>
              </ul>
              <p>8.2如您的行为违反了相关法律法规、或主管机关规章的，则在上述我们可采取的措施的基础上，在法律允许的最大范围内，我们还有权调查，向司法机关举报，或起诉（或参与和协助执法部门起诉）任何上述违法违规行为。 </p>
              <p>8.3如因您的行为导致{company}为任何第三方主张或索赔，或为主管机关处罚的，{company}有权随时向您追偿，包括但不限于本产品向第三方支付的赔偿/补偿、罚款、诉讼费、律师费、仲裁费等为实现债权所支出的全部成本。</p>
              <span className="tit_span">9.陈述与保证</span>
              <p>9.1您在提供网约车承运服务时，您的车辆和您本人均符合《网络预约出租汽车经营服务管理暂行办法》等应适用法律法规的相关要求，否则由您承担任由此引起的任何后果和法律责任，{company}有权随时向您追责并采取一切我们认为合理的措施;</p>
              <p>9.2您不得私自更换车辆、出借账号，应保证您本人和提供网约车承运服务的车辆与在本产品账号中所提供的车辆、驾驶员信息一致。如您的个人信息和车辆与账户信息不一致的，{company}有权随时向您追责并采取一切我们认为合理的措施;</p>
              <p>9.3您不得在提供网约车承运服务的情况下，单独运送物品，或接受乘客单独要求运送物品的网约车订单;遇到该等网约车承运服务订单的，您应当拒绝运送并取消行程、上报我们。如您违反本项规定私自接受单独运送物品的订单的，您将自行承担由此产生的任何法律责任，{company}可以随时向您追责并采取一切我们认为合理的措施; </p>
              <p>9.4您不得在提供承运的车辆内携带危险品或者其他法律、法规规定禁止或不适宜携带的物品，否则由您承担任由此引起的任何后果和法律责任，{company}有权随时向您追责并采取一切我们认为合理的措施;</p>
              <p>9.5您不得在提供服务过程中进行违反法律法规、本协议及本产品相关规则的行为，因您违反法律法规和本协议、本产品相关规则而导致有关部门行政处罚，或任何人身伤亡和/或财产损失的，您将自行承担由此产生的任何后果和法律责任，{company}有权随时向您追责并采取一切我们认为合理的措施;</p>
              <p>9.6您在接受{company}所提供的网约车订车派送服务过程中，不得将本产品其他用户信息提供给任何第三人，亦不得将在依据本协议提供承运服务的过程中获得的任何乘客信息提供给任何第三人;</p>
              <p>9.7您在此确认并同意，严格遵守中华人民共和国法律法规、公序良俗，以及本协议的约定;不会利用本产品于任何非法目的和侵犯他人合法权利;一旦发现，我们保留立即终止向您提供服务、终止本协议的权利。</p>
              <p>9.8您在接单或服务乘客过程中，您需要按照本协议的约定及本产品相关规则的规定对服务质量和驾驶安全予以保证，我们将按照本协议的约定及本产品相关规则对您的行为进行监督。如由于您的过错给第三方造成的侵权损害，应该由您承担相应的赔偿责任;如我们有为您代为先行垫付的，或因您违约给我们造成损失的，我们有权向您进行追偿。</p>
              <span className="tit_span">10.不可抗力与免责</span>
              <p>10.1您理解并同意，对于下述不可预见、不可避免或不可克服的原因导致我方无法或未能及时（或充分）履行本协议项下对您的义务的（包括但不限于延迟履行或履行内容变更、数据丢失等情形），本产品在法律允许的最大范围内免责∶</p>
              <p>10.1.1自然灾害、罢工、劳动争议、暴乱、骚乱、爆炸、战争、政府行为、国家或地区法律法规或政策变更，司法行政命令;</p>
              <p>10.1.2电力供应中断、运营商通讯网络故障（包括导致通讯失败或延时、通讯被拦截和操纵）等公共服务因素; </p>
              <p>10.1.3您自身因素（包括但不限于您操作不当、通过未经授权的方式使用本服务）或第三人因素（包括但不限于遭受第三方计算机病毒或黑客攻击、木马或其他恶意插件程序、乘客的错误下单等错误操作）;</p>
              <p>10.1.4因本产品合理的常规或紧急设备与系统维护、设备与系统故障、缺陷、网络信息与数据安全、技术风险等因素;以及</p>
              <p>10.1.5其他无法控制或合理预见的情形。</p>
              <p>10.2如果{company}因上述原因导致的无法履行、延迟履行、不完整履行，或处理错误（以下统称"处理错误"），您确认并同意，无论有利于本产品还是有利于您，本产品都有权在根据本协议通知您后纠正该错误。您理解并同意，您因前述处理错误而多收或少收的款项均不计利息，本产品不承担因前述处理错误而导致的任何损失或责任（包括您可能因前述处理错误导致的利息、汇率等损失）。</p>
              <p>10.3本产品仅对因我方原因给您造成的直接、实际损失依法承担相应的赔偿责任，不对任何间接损失、惩罚性赔偿承担责任。 </p>
              <span className="tit_span">11.责任限制</span>
              <p>我们将在合理的范围内尽力保证本产品内为您提供的信息准确，但无法保证其中没有任何错误、缺陷、恶意软件和病毒。本产品不承担非因我方故意或重大过失而使您在使用本产品过程中产生的任何损失。 </p>
              <span className="tit_span">12.协议的修改、更新</span>
              <p>12.1本协议内容包括本协议条款、《隐私政策》以及其他经本产品不时修订、修改，并在本产品内发布的通知、规则或规定，上述约定均为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
              <p>12.2为更好的提升用户体验及服务，您确认并同意{company}有权不定期对本协议进行修改更新，修改更新后的协议一经正式发布，将以适当方式（包括但不限于弹窗、公告、站内信等）提醒您，同时，您可随时访问{company}了解最新协议条款。当发生有关争议时，以最新的协议条款为准;如您对修改后的协议有异议，请立即停止登陆、使用{company}的服务，若您继续登陆或使用，则视为您已充分阅读、理解并接受更新后的协议约定。</p>
              <span className="tit_span">13.法律适用与管辖</span>
              <p>您访问和使用{company}服务，即表示您同意本协议及该访问或使用服务受中华人民共和国法律的约束。因本协议产生的任何争议，应友好协商解决;协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。 </p>
              <span className="tit_span">14.特别约定</span>
              <p>14.1您访问和使用{company}服务，即视为您认可与我们（具体公司列表见此处）建立服务合作关系。 </p>
              <p>14.2您同意并认可本协议及其不时修改或替换的内容受《合同法》等民事法律约束，我们与您之间不存在任何直接或间接的劳动关系，不适用《劳动法》、《劳动合同法》、《社会保险法》、《住房公积金管理条例》等法律法规。</p>
              <p>14.3如果本协议的部分被认定为无效而其他条款仍能保持有效且其执行不受影响，本产品有权决定是否继续履行该等其他条款。</p>
              <p>14.4本协议自您注册{company}账号时同意确认后即生效，除任一方根据本协议的约定提前终止本协议的，协议期限为长期。</p>
              <p>14.5您确认与同意，在发生本协议项下我们有权单方解除本协议的情形的，我们无义务提前通知您本协议的终止，我们有权（但非义务）以移动运营商短信方式将此相关事宜通知您。</p>
              <h3>第二部分∶</h3>
              <h4>{company}用户规则</h4>
              <h5>本《用户规则》更新日期∶2021年04月19日</h5>
              <p>本用户规则适用于使用{company}服务的司机。
              </p><p>
                本用户规则将不时修订、修改，修改更新后的《用户规则》将以适当方式（包括但不限于弹窗、公告、站内信等）进行提醒，您也可随时访问{company}了解最新《用户规则》的内容。</p>
              <span className="tit_span">一、车辆准入标准</span>
              <p>1.注册成为{company}的驾驶员，其用于运营的车辆应当符合本用户规则的准入标准;如不符合的，{company}有权对其绑定车辆予以解绑或暂停其服务直至其完成相应的改进措施。</p>
              <p>2.车辆安全装置符合规定:各区域和城市要求车辆安装具有行驶记录功能的卫星定位装置、应急报警装置、影音记录、车载硬件装置或张贴车辆标识的，从其规定。 </p>
              <p>3.车辆保险符合规定：车辆具有投保有效期限内的机动车交通事故责任强制保险;根据各地法律规定或根据各区域和城市要求，车辆需购买座位险、第三责任险、网络预约出租车营运险的，从其规定。</p>
              <p>4.车辆其他准入标准</p>
              <p>4.1车辆为非油改气车辆，但当地法律法规另有规定的，从其规定。</p>
              <p>4.2车辆按照国家规定进行年检。</p>
              <p>4.3车辆行驶里程未超过60万公里或车龄未超过8年的，但当地规定车辆注册年限低于8年的，从其规定。</p>
              <span className="tit_span">二、司机准入标准</span>
              <p>1.注册成为{company}驾驶员的车主用户，应符合本用户规则的准入标准;如不符合的，平台可终止其司机服务资格或由要求其整改以符合司机准入标准。</p>
              <p>2.身份证</p>
              <p>2.1女性年龄在21-55周岁之间，男性年龄在21-60周岁之间，各地实施的法律法规另有规定的，从其规定; 2.2身份证信息填写正确，无任何涂改、伪造、篡改。 </p>
              <p>3.驾驶证</p>
              <p>3.1取得相应准驾车型机动车驾驶证并具有3年以上驾驶经历;</p>
              <p>3.2机动车驾驶证载明的准驾车型为A1、A2、A3、B1、 B2、C1或C2，且满足申领C2 以上驾驶证的身体标准要求，但当地有特殊规定的，从其规定。机动车驾驶证载明的准驾车型为C5的，应取得网约车双证;</p>
              <p>3.3最近连续3个记分周期内没有记满12分记录或上个记满 12分周期已满3年之中华人民共和国机动车驾驶证真实有效。 </p>
              <p>4.行驶证</p>
              <p>4.1车辆类型为小型汽车或微型汽车，但小型专用客车除外;
             </p><p> 4.2核载人数为5-7人;</p>
              <p>4，3非政府公用车及其他专用车辆;</p>
              <p>4.4按照当地政府要求及时更换网络预约车合格车型， </p>
              <p>5.身体状况</p>
              <p>5.1未患有妨碍安全驾驶机动车的疾病（如器质性心脏病、癫痫病、美尼尔氏症、眩晕症、癔病、震颤麻痹、精神病、痴呆以及影响肢体活动的神经系统疾病等）; </p>
              <p>5.2无带病驾驶记录的。</p>
              <p>6.司机其化准入标准</p>
              <p>6.1无犯罪记录 （含交通肇事犯罪、危险驾驶犯罪、暴力犯罪等）;</p>
              <p>6.2未因涉嫌犯罪处于被调查、侦查、审查起诉、审判阶段或被公安机关列入在逃人员名单的; </p>
              <p>6.3无吸毒记录; </p>
              <p>6.4无饮酒后驾驶记录。</p>
              <span className="tit_span">三、准入。{company}监督检查规则</span>
              <p>1.注册成为{company}用户并激活成为网约车司机（以下简称"司机"），应满足国家法律法规及地方各级政府对网络预约出租车管理的规定，并应满足{company}的准入标降。</p>
              <p>2.用户注册司机，应如实按照《用户服务协议》相关约定提供相应的信息及资料供{company}审核，并对资料的真实性、准确性和完整性负责。</p>
              <p>3.{company}将尽最大努力对用户是否满足准入标准予以审核。经审核满足准入条件的，可激活成为网约车司机。</p>
              <p>4.用户激活成为网约车司机后，被{company}发现实际不满足准入标准或者因自身情况变化不再符合准入标准的，{company}可终止其司机服务资格或责令其改正以满足准入标准。</p>
              <p>5 司机明知自己不符合准入标准仍激活为网约车司机，或者所提供信息、资料与其真实信息或情况不符的，不予准入，已
经准入的永久停止服务，给其他用户或{company}造成损失的，{company}将依法追究其法律责任。</p>
              <p>6.{company}有权利对注册司机用户的行为及车辆的状况进行监督和管理，司机用户违反下列规定的情形的，{company}可对其永久停止服务并对其所绑定的车辆予以解绑∶</p>
              <p>6.1司机应按照{company}规定进行人脸核验;</p>
              <p>6.2司机应本人接单，不得将注册账号买卖、出借、赠予他人;</p>
              <p>6.3司机不得将本人注册账号下的注册车辆出借给他人用于接单;</p>
              <p>6.4司机应使用注册车辆进行接单，同时绑定多辆车辆的，应确保实际接单车辆与系统显示的接单车辆一致。</p>

              <span className="tit_span">四、司机违约责任规则和服务规则</span>
              <p>为了保证乘客安全出行，规范司机的服务规范，制定如下司机违约责任规则。 </p>
              <span className="tit_span">1.订单取消规则</span>
              <p>司机服务过程发生如下行为，首次将给予警告;情节严重或警告后未改正，将暂停服务5-7天或30天;情节恶劣的，或金额巨大的，或产生重大不良影响的，永久停止服务。并且，根据违规情节轻重，收取单次30~200元不等的违约金。</p>
              <p>1.1司机故意偏离导航或者反方向行驶导致订单取消; <br />
              1.2司机长时间停留未去前往接乘客导致订单取消;<br />
              1.3司机多次拒接乘客电话导致订单取消;<br />
              1.4无正当理由，司机未按照{company}要求完成服务 <br />
              1.5司机迟到导致订单取消;<br />
              1.6司机到达上车点后走远导致订单取消;<br />
              1.7司机提前点击我已到达，导致订单被取消; <br />
              1.8司机多次违规行为导致订单取消; <br />
              1.9司机等候时间不足导致订单取消; <br />
              1.10司机诱导乘客取消订单;<br />
              1.11其他可归责于司机的原因导致订单取消（例如∶服务态度）。 </p>

              <span className="tit_span">2.收费规则</span>
              <p>司机服务过程发生如下行为，首次将给予警告并扣取不正当所得费;情节严重或警告后未改正，将暂停服务5-7天或30天;情节恶劣，或金额巨大的，或产生重大不良影响的，永久停止服务。并且，根据违规情节轻重，收取单次30~200元不等的违约金。 </p>
              <p>2.1多收费<br />
2.1.1乘客未上车司机通过计费结束订单规避取消责任; <br />
2.1.2因司机接错人导致未接到乘车乘客收费; <br />
2.1.3因司机APP操作失误导致未向乘车乘客收费。 <br />
2.2加价议价<br />
2.2.1司机与乘客加价议价;<br />
2.2.2非现金订单司机与乘客现金支付;<br />
2.2.3乘客有其它超出订单服务范围的服务要求时司机有权<br />
2.3绕路<br />
2.3.1因司机路线不熟或者看错导航导致订单发生绕路; <br />
2.3.2因司机擅自变更路线导致订单发生绕路，{company}将扣除不当所得返还乘客。 <br />
2.4未及时结束计费<br />
2.4.1司机原因导致订单未被及时结束发生费用纠纷。<br />
2.5提前开始扣费<br />
2.5.1因司机APP操作失误导致乘客未上车开始计费; 2.5.2因乘客迟到司机擅自开始计费等待的费用纠纷。<br />
2.6多收附加费<br />
2.6.1司机添加自定义费用至附加费导致订单发生费用红纷;<br />
2.6.2司机未按照{company}规定，向乘客收取订单时间外产生的停车费/过路费导致订单发生费用纠纷;<br />
2.6.3司机未按照{company}规定，添加自定义费用至其他费用导致订单发生费用纠纷。 </p>
              <p>3.服务质量<br />
司机服务过程发生如下行为，首次将给予警告;情节严重或警告后未改正，将暂停服务5-7天或30天;情节恶劣的，或金额巨大的，或产生重大不良影响的，永久停止服务。并且，根据违规情节轻重，收取单次30~200元不等的违约金。 <br />
3.1服务态度 <br />
3.1.1乘客无法联系到司机。 司机接单后。乘客无法联系到司机，导致乘客投诉，且司机无正理由; <br />
3.1.2车主迟到∶司机无正当理由迟到或者未及时赶往乘客上车点; <br />
3.1.3服务环境差∶ 司机车辆脏乱，差，车内有烟味导致乘客投诉; <br />
3.1.4司机服务态度不佳∶ 司机服务态度不佳，被乘客投诉; <br />
3.1.5中途甩客∶ 司机违反{company}规则，服务中途要求乘客下车，或者下车地点不符合{company}规定;  <br />
3.1.6拒载∶司机违反{company}规则，服务不按照要求接驾乘客; <br />
3.1.7拼车。 接驾途中，接送其他乘客，  <br />
3.2线下交易 <br />
3.2.1司机要求线下交易或乘客要求线下交易，且双方实际完成线下交易的; <br />
3.2.2司机将乘客交给其他司机车辆提供服务的; <br />
3.3物品遗失 <br />
3.3.1司机拾得其他用户财物后，归还时索要不合理的费用; <br />
3.3.2司机拾得其他用户财物后后拒绝归还。 </p>
              <p>4.干扰运营秩序<br />
司机服务过程发生如下行为，首次将给予警告;情节严重或警告后未改正，将暂停服务5-7天或30天;情节恶劣的，或金额巨大的，或产生重大不良影响的，永久停止服务。并且，根据违规情节轻重，收取单次30~200元不等的违约金。<br />
4.1司机以非法占有的目的，用虚构的事实或者隐藏真相的方法，骗取{company}或者其他用户、乘客的现金; <br />
4.2恶意投诉∶司机捏造其他用户存在损害其他人身财产权益、安全行为的事实;<br />
4.3司机使用{company}申诉服务时，拒不配合工作人员<br />
核实情况，或者恶意辱骂威胁工作人员，或者传播淫秽内容;<br />
4.4司机不得向其他用户索要联系方式，包括但不限于电话、微信、QQ等，但为处理尚未解决的纠纷且与对方协商一致联系方式的除外;<br />
4.5司机存在其他严重扰乱{company}秩序的行为。 </p>
              <p>5.安全行驶<br />
司机服务过程发生如下行为，首次将给予警告;情节严重或警告后未改正，将暂停服务5-7天或30天;情节恶劣的，或金额巨大的，或产生重大不良影响的，永久停止服务。并且，根据违规情节轻重，收取单次100~500元不等的违约金。<br />
5.1在15天内司机被乘客投诉分心驾驶，通过路口不减速驾驶时饮食，抽烟或者存在其他不文明驾驶行为，{company}给予警告;警告后拒不改正，暂停服务5-7天;情节严重的，暂停服务15天-30天;造成严重后果永久封号。<br /> 5.2司机驾驶车辆，发生交通事故，致他人轻伤以下伤情，车主负同等以上责任，{company}给予警告;警告后拒不改正，暂停服务5-7天;情节严重的，暂停服务15天-30天;造成严重后果永久封号。<br />
5.3司机违反道路交通法律规定，影响驾驶安全行为，{company}给予警告;警告后拒不改正，暂停服务5-7天;情节严重的，暂停服务15天-30天;造成严重后果永久封号。<br /> 5.4司机驾驶车辆，发生交通事故，致他人伤害及死亡。司机负同等责任，但尚未构成交通肇事犯罪，永久停止服务。 </p>
              <p>
                6.严重违规<br />
司机服务过程发生如下行为，一旦发现，永久停止服务并且收取单次300-500元不等的违约金。 <br />
6.1猥亵，永久停止服务;<br />
6.2信息骚扰，用户通过短信、微信 等沟通工具向其他用户发送信息进行叨扰，发送不雅信息不雅视频进行骚扰的，永久停止服务;<br />
6.3语言骚扰∶用户与其他面对面，电话或者语音沟通使用轻浮暖昧等不当语言或者第三方沟通不雅内容，对其他用户产生不良影响;<br />
6.4司机车内放置不雅图片，物品等行为情节严重; <br />
6.5订单过程中播放不雅音视频; <br />
6.6触摸其他用户的身体。情节严重;<br />
6.7其他被认为骚扰的行为;<br />
6.8侵犯隐私，偷拍散布用户隐私或者泄露其他用户个人信息，侵犯隐私，偷拍散布用户隐私或者泄露;<br />
6.9以各种方式恶意干扰、损害{company}运营的行为，包括但不限于网络诋毁、下单干扰、恐吓骚扰员工等; <br />
6.10恶意针对{company}，以组织集会、示威威胁、围堵等方式严重影响、扰乱{company}业务运营的行为等;<br />
6.11司机注册后，存在酒驾、运毒、强奸、抢劫等违法行为，且被公安机关认定属实的违法犯罪行为，一旦发现永久停止服务;<br />
6.12在服务过程中，司机存在酒驾、携带枪支，弹药，匕首等管制器具的违法行为;<br />
6.13司机注册前存在犯罪记录（如∶交通肇事罪、吸毒记录、暴力犯罪记录等），并伪造事实通过{company}审核的;<br />
6.14司机行为构成犯罪，包含交通肇事犯罪，危险驾驶，暴力犯罪等及其他犯罪行为;<br />
6.15肢体冲突∶ 与其他用户发生肢体冲突或者在订单过程中存在其他暴力行为，造成人身伤害，造成他人轻微护着其他伤害;<br />
6.16限制人身自由∶不允许乘客下车或者其他方式限制乘客人身自由;<br />
6.17抢劫或者抢夺他人财物，盗取骗取勒索他人财物; <br />
6.18司机威胁恐吓，以暴力恐吓等手段威胁其他人身安全。<br />
              </p>
              <p>7.物品遗失处理流程规则<br />
7.1物品遗失规则及处理流程需遵守《中华人民共和国物权法》及相关法律、法规规定。<br />
7.2司机拾得其他用户财物后，需要报备{company}。司机除与乘客沟通协商一致后收取遗失物品产生的保管费、运输费外，不得在归还时索要其他不合理费用。<br />
7.3司机在乘客领取遗失物品前或者交给公安部门之前，应妥善保管遗失物，积极协助乘客领取遗失物品，不得恶意增加乘客用户领取遗失物的难度和成本。<br />
7.4司机因故意或者重大过失致使遗失物毁坏（包含数据毁坏如刷新，电脑格式化）或因过错导致物品再次遗失，应赔偿乘客损失。<br />
7.5司机与遗失物品乘客就物品领用协商不一致，司机应该在与乘客用户协商结束后48小时内将遗失物送至公安部门，否则视为变相拒绝归还遗失物，司机将物品交送和公安部门应告知乘客公安部门名称和地址，并且向{company}报备。<br />
7.6司机侵占乘客遗失物品，依法承担相应的法律责任，构成犯罪，移送司法机关给予处理。<br />
7.7司机不得将遗失物拆解进行检视，如司机判断是可疑物品需要报备{company}，并且送至公安部门。 </p>
              <p>8.司机取消规则 <br />
8.1司机取消无责<br />
司机在下列情形下取消订单，无需承担违规责任。但是，如司机捏造，虚假向{company}报备及申请无责取消订单，我们在核实后将按照本用户规则进行处理。 <br />
8.1.1乘客是未成年人，没有同行家长/成年人陪同的; <br />
8.1.2乘客是醉酒并且没有同行人，且司机认为可能危害自身安全;<br />
8.1.3因乘客不在乘车情况下，要求司机单独运送货物; <br />
8.1.4乘客人数超过车内座位;<br />
8.1.5因乘客携带宠物或者活禽，未与司机协商一致，或者虽协商一致但是未放入宠物箱等容器的;<br />
8.1.6乘客要求线下交易或者议价;<br />
8.1.7乘客携带的物品超过车辆后备箱的可容纳范围; <br />
8.1.8司机通过合理的方式均无法联系上乘客（司机电话联系乘客3次以上）;<br />
8.1.9因极端天气、自然灾害等不接抗力因素导致司机无法继续接驾的;<br />
8.1.10因修桥、修路及封路等原因导致司机无法继续接驾。<br />
8.2预约单规则 <br />
8.2.1司机无责取消订单∶<br />
在下列情形下，司机取消预约订单的，无需承担违规责任，但是司机不得诱导、胁迫要求乘客取消订单。如果司机捏造事实虚假向{company}报备申请无责取消订单，我们将给予警告;警告后再次违规的，则暂停服务5-30日;情节严重将永久暂停服务。<br />
8.2.1.1乘客未按照约定时间到达指定上车点，且司机无法联系乘客 （联系次数至少2次），等候时间10分钟内取消。 <br />
8.2.2司机有责取消订单∶<br />
司机无正当的理由取消。诱导要求胁迫乘客取消订单。因司机违反{company}要求规则导致乘客取消订单，{company}对司机警告并且可对其暂停服务5-30日，并从司机账户扣除300-500元不等的违约金;情节严重及涉及金额巨大将永久停止服务。<br />
8.2.2.1司机故意偏离导航或者反方向行驶导致订单取消; <br />
8.2.2.2司机长时间停留未去前往接乘客导致订单取消; <br />
8.2.2.3司机多次拒接乘客电话导致订单取消;<br />
8.2.2.4无正当理由，司机未按照{company}要求完成服务;<br />
8.2.2.5司机迟到导致订单取消;<br />
8.2.2.6司机到达上车点后走远导致订单取消; <br />
8.2.2.7司机提前点击我已到达，导致订单被取消; <br />
8.2.2.8司机多次违规行为导致订单取消; <br />
8.2.2.9司机等候时间不足导致订单取消; <br />
8.2.2.10司机诱导乘客取消订单;<br />
8.2.2.11其他可归责于司机的原因导致订单取消（例如∶服务态度）。<br />
8.2.3预约单服务准则<br />
8.2.3.1司机服务预约单后应做到，主动帮乘客提放行李，并在接到订单后拨打乘客电话进行行程确认，并在上车前 30分钟内，确定上车时间与地点;注意服务态度，使用文明用语;严禁擅自进行违规操作。<br />
8.2.3.2司机服务预约单时候，应保证车内整洁，必须按时到达约定地点;如未见乘客，拨打乘客电话联系;严禁司机提前按"已接到乘客"。如司机不得已发生迟到，请及时与乘客沟通。<br />
8.2.3.3行车服务中∶与乘客沟通是否有指定路线;当面点击开始计费;如未按正确流程进行服务; （例如提前产生费用、绕路等）将严厉处罚。绕路问题的主要解决方法∶首先是询问乘客是否有指定路线，未上车产生费用的主要解决方法∶当面点击开始计费。<br />
8.2.3.4行车结束∶提前询问乘客停车地点;当遇需要收费或不确定是否收费的停车地点，请与乘客沟通协商;注意服务态度、语言文明。司机平稳停车，当场结束计费;提醒乘客携带好随身物品;保护好司乘双方权益。</p>
              <h3>第三部分∶</h3>
              <h4>网约车行业个人信息共享授权书</h4>
              <p>为了维护网约车出行安全、实现行业有序发展，进一步创造更加和谐安全的出行环境，作为{company}的注册司机，本人同意，如本人在提供网约车服务的过程中违反法律法规被国家机关采取强制措施或者予以处罚 （包括但不限于刑事犯罪、治安拘留），或因严重违反{company}用户规则 （包括但不限于严重性骚扰、严重侵害乘客人身、财产安全等）被{company}依规处理， {company} 可以与其他网约车平台共享本人基本信息 （包括姓名、身份证号、手机号）及本人违法违规情况。其他网约车平台可以根据共享的信息判断是否接纳本人作为网约车司机或者是否依据其平台规则对本人进行处理。</p>
              <p>如本人在其他网约车平台发生上述行为，则授权{company} 从其他网约车平台收集本人基本信息及违法违规情况，以判断是否接纳本人作为网约车司机或者是否依据其平台规则对本人进行处理。</p>
              <p>本人同意，各网约车平台分别对其收集的个人信息承担安全保护义务，因其他网约车平台不当使用个人信息，造成数据泄露或其他损失的，由不当使用或者泄露个人信息的网约车平台承担法律责任， {company} 不需承担责任。</p>
              <p>本授权书自本人点击确认之日起生效。</p>
            </div>

          </Bscroll>
        </div>
      </div>
    </div>
  )
}
export default connect(mapStateToProps)(ServiceTerm)
